export const normalizeCredentialField = (field) => {
  if (typeof field === 'string') {
    return { key: field.trim(), defaultValue: '' };
  }

  if (!field || typeof field !== 'object') {
    return { key: '', defaultValue: '' };
  }

  const key = String(field.key ?? field.name ?? field.label ?? '').trim();
  const defaultValue = field.defaultValue ?? field.default_value ?? field.value ?? '';

  return {
    key,
    defaultValue: String(defaultValue ?? '')
  };
};

export const normalizeCredentialFields = (fields = []) => {
  const seen = new Set();
  return (Array.isArray(fields) ? fields : [])
    .map(normalizeCredentialField)
    .filter((field) => {
      if (!field.key || seen.has(field.key)) return false;
      seen.add(field.key);
      return true;
    });
};

export const getCredentialKey = (field) => normalizeCredentialField(field).key;

export const getCredentialDefaultValue = (field) => normalizeCredentialField(field).defaultValue;

export const getEffectiveCredentialValue = (envCreds, field) => {
  const normalized = normalizeCredentialField(field);
  if (!normalized.key) return '';

  const currentValue = envCreds?.[normalized.key];
  if (currentValue != null && String(currentValue).trim()) {
    return String(currentValue);
  }

  return String(normalized.defaultValue || '');
};

export const hasEffectiveCredentialValue = (envCreds, field) => (
  !!String(getEffectiveCredentialValue(envCreds, field)).trim()
);
